import { convertFromRaw } from 'draft-js';
import { blocksConfig } from './config';
export var transformGenericToDraftjsState = function transformGenericToDraftjsState(genericContentState) {
  var initialRawDraftContentState = {
    blocks: [],
    entityMap: {}
  };
  var rawDraftContentState = genericContentState.blocks.reduce(function (accRawDraftContentState, currentGenericBlock) {
    var blockConfig = blocksConfig[currentGenericBlock.type];

    if (blockConfig === undefined) {
      return accRawDraftContentState;
    }

    return blockConfig.transformToDraftjsAndAppend(currentGenericBlock, accRawDraftContentState);
  }, initialRawDraftContentState);
  return convertFromRaw(rawDraftContentState);
};